import React, {useEffect, useRef} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {getRoomOfferAnalyticsContexts} from 'middleware/analytics/selectors'

import {useInView} from '@vio/core/src/_web/utils/browser/hooks/useInView'
import {Action, Category} from '@vio/core/src/analytics/types/Events'
import {Offer} from '@vio/core/src/offer/types/offer'
import {
  DealFreezeBannerVariant,
  trackDealFreezeBanner
} from '@vio/shared/src/dealFreeze/components/common/bannerTracking'
import {ComponentSource} from '@vio/shared/src/dealFreeze/types'

import {DealFreezeBanner} from './DealFreezeBanner'

interface Props {
  offer: Offer
}

export const RoomOfferDealFreezeBanner: React.FC<Props> = ({offer}) => {
  const analyticsContext = useSelector(state =>
    getRoomOfferAnalyticsContexts(state, offer.id)
  )
  const dispatch = useDispatch()
  const {ref, inView} = useInView({threshold: 0, initialInView: false})
  const hasTrackedRef = useRef(false)

  useEffect(() => {
    if (!inView || hasTrackedRef.current) return
    hasTrackedRef.current = true

    dispatch(
      trackDealFreezeBanner({
        category: Category.System,
        action: Action.Displayed,
        variant: DealFreezeBannerVariant.Standing,
        analyticsContext,
        component: ComponentSource.HotelViewRoomsSection
      })
    )
  }, [inView, dispatch, analyticsContext])

  return (
    <div ref={ref}>
      <DealFreezeBanner />
    </div>
  )
}
